import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GlobalMessageService } from '../../global-services/global-message.service';
import { GlobalLoadingService } from '../../global-services/global-loading.service';
import { FirebaseService } from '../../global-services/firebase.service';
import { Router } from '@angular/router';

export type ObCreateOrgUiState = 'idle' | 'success';

@Injectable({ providedIn: 'root' })
export class ObCreateOrgFacade {
  private stateSubject = new BehaviorSubject<ObCreateOrgUiState>('idle');
  state$ = this.stateSubject.asObservable();

  constructor(
    private loading: GlobalLoadingService,
    private message: GlobalMessageService,
    private firebaseService: FirebaseService,
    private router: Router
  ) {}

  start() {
    this.stateSubject.next('idle');
  }

  async createOrg() {
    this.loading.show();
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1200));
    this.loading.hide();
    this.stateSubject.next('success');
    this.message.showSuccess(
      'Organisation created',
      'Your organisation has been created.'
    );
  }

  async signOut() {
    this.loading.show();
    await this.firebaseService.signOut();
    this.message.showSuccess(
      'Sign Out Successful',
      'You have been signed out successfully.'
    );
    this.loading.hide();
    this.router.navigate(['/sign-in']);
  }

  goToDashboard() {
    // Implement navigation logic here, e.g., using Angular Router
    this.message.showSuccess('Redirect', 'Going to dashboard...');
  }
}
